module.exports = __webpack_public_path__ + "static/media/overall3.5f8ee11a.png";